module.exports = __webpack_public_path__ + "static/optimisation-06687922223b5ba96533b45f60431488.jpg";